/*
 * @Author: kangzhuang 742291831@qq.com
 * @Date: 2025-04-16 09:21:14
 * @LastEditors: kangzhuang 742291831@qq.com
 * @LastEditTime: 2025-04-16 09:24:36
 * @FilePath: \qrcode-web\src\utils\element-ui.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";

import { Card, Form, FormItem, Input, Button, Message } from "element-ui";

Vue.use(Card);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Button);

Vue.prototype.$message = Message;
